<template>
    <div>
        <b-overlay :show="loading" no-wrap rounded></b-overlay>
        <form action="#" @submit.prevent="onSubmit" ref="resForm">
            <b-form-group label="Enviar *">
                <b-form-checkbox-group v-model="notificationsSelected" :options="notificationsOptions">
                </b-form-checkbox-group>
            </b-form-group>
            <b-form-row v-if="isMailSelected">
                <b-form-group class="col-12" label="Email *">
                    <b-form-input type="email" size="sm" v-model="email" required />
                </b-form-group>
            </b-form-row>
            <b-form-row v-if="isSmsSelected">
                <b-form-group class="col-12" label="Telefono *">
                    <b-form-input size="sm" v-model="viewModel.clientPhone" required disabled />
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group class="col-12" label="Idioma *">
                    <b-form-select size="sm" v-model="lang" required>
                        <b-form-select-option value="en">Ingles</b-form-select-option>
                        <b-form-select-option value="es">Español</b-form-select-option>
                    </b-form-select>

                    <b-form-checkbox size="sm" v-model="changeLangValue" v-if="changeLang">
                        Cambiar el idioma del cliente en la reserva
                    </b-form-checkbox>
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group class="col-12" label="Template *">
                    <b-form-select :options="optionsTemplates" v-model="templateSelected"></b-form-select>
                    <div v-if="descriptionTemplate !=''">
                        <span>
                            <md-icon class="text-warning" :icon="'info'"></md-icon>
                            {{descriptionTemplate}}
                        </span>
                    </div>
                </b-form-group>
            </b-form-row>

            <b-form-row v-if="templateItems.show">
                <b-form-group class="col-12" label="Seleccione una opción:">
                    <b-form-radio-group v-model="templateItemSelected" :options="templateItems.options" disabled-field="disabled"></b-form-radio-group>
                </b-form-group>
            </b-form-row>

            <b-alert variant="danger" v-if="(logsHtml.length>0)" show dismissible>
                <div v-html="logsHtml" class="text-center"></div>
            </b-alert>

            <b-form-row v-if="(previewSms!==null && previewSms.length>0) && isSmsSelected" class="mt-3">
                <label class="mb-0 text-center">
                    <md-icon :icon="'textsms'"></md-icon> Preview SMS
                </label>
                <b-form-textarea disabled rows="2" class="mt-0" :value="previewSms"></b-form-textarea>
                <span>{{ previewSms.length}} caracteres</span>
            </b-form-row>

            <hr />
            <div class="text-right">
                <b-button variant="primary" type="submit">Enviar</b-button>
            </div>

            <b-overlay :show="showConfirmation" no-wrap>
                <template #overlay>
                    <div ref="dialog" tabindex="-1" role="dialog" class="text-center p-1">
                        <p>
                            <strong id="form-confirm-label">¿Desea enviar la notificación?</strong><br>
                        </p>
                        <div class="text-danger">
                            <p><b> {{templateSelected.title}}</b></p>
                            <p v-if="isMailSelected">El EMAIL
                                 se enviará a <br>
                                <b>{{email}}</b>
                            </p>
                            <p v-if="isSmsSelected">El SMS se enviará a <br>
                                <b>{{viewModel.clientPhone}}</b>
                            </p>
                            <div />
                            <div class="text-center">
                                <b-button variant="outline-danger" class="mr-3" @click="()=>{showConfirmation=false}">
                                    Cancelar
                                </b-button>
                                <b-button variant="outline-success" @click="onConfirm">Confirmar</b-button>
                            </div>
                        </div>
                    </div>
                </template>
            </b-overlay>
        </form>

    </div>
</template>

<script>
import api from "../../../../api.js";
import MdIcon from "../../../helpers/MdIcon.vue";
import {mapState} from "vuex";
export default {
    props: {
        listPayments: {
            type: Array,
            required: true
        },
        listTemplates: {
            type: Array,
            required: true
        },
        selected:{
            type:Object,
            required:false,
            default:()=>({})
        }
    },
    components: { MdIcon },
    data() {
        const templateModelDefault = {
            code: '',
            description: '',
            langTemplates: {},
            model: "",
            templateDefault: -1,
            title: '',
        }
        return {
            templateModelDefault:{...templateModelDefault},
            notificationsOptions: [
                { text: "Mail", value: "mail" },
                { text: "Sms", value: "sms" },
            ],
            loading: false,
            clientLang:"en",
            lang: "en",
            email:"",
            templateSelected: {...templateModelDefault},
            changeLangValue: false,
            showConfirmation: false,
            logsHtml: "",
            previewSms: "",
            notificationsSelected: ["sms", "mail"],
            templateItemSelected: 0
        };
    },
    methods: {
        onSubmit(event) {
            try {
                if (this.templateSelected === null) {
                    throw "Seleccione una plantilla";
                }
                if (this.notificationsSelected.length==0) {
                    throw "Notificación a enviar es requerido";
                }
                event.preventDefault();
                this.showConfirmation = true;
            } catch (Err) {
                  this.$root.showAlert(Err,{variant:"danger"});
            }

        },
        onConfirm() {
            this.showConfirmation = false;
            this.loading = true;
            let aux = {
                id: this.viewModel.id,
                email: this.email,
                changeLanguage: this.changeLangValue,
                language: this.lang,
                template: this.templateSelected.code,
                itemSelected: this.templateItemSelected,
                notificationsToSend: this.notificationsSelected,
            };
            api(this)
                .post(`/notifications/send`, aux)
                .then((res) => {
                    this.$root.$emit(
                        "bv::refresh::table",
                        "reservations-mail-history-list"
                    );
                    if (res.data.success) {
                        this.$root.showAlert("Realizado");
                        this.logsHtml = res.data.logsHtml;
                        if (this.changeLangValue) {
                            this.clientLang = this.lang;
                        }
                    } else {
                        this.$root.handleRequestError(res.data.error);
                    }
                })
                .catch((error) => {
                    this.$root.handleRequestError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onPreviewSms() {
            if (this.templateSelected.code != '') {
                try {
                    this.loading = true;
                    let aux = {
                        id: this.viewModel.id,
                        language: this.lang,
                        template: this.templateSelected.code,
                        itemSelected: this.templateItemSelected,
                    };
                    api(this)
                        .get(`/notifications/preview/sms`, { params: aux })
                        .then((res) => {
                            this.previewSms = res.data;
                        })
                        .catch((error) => {
                            this.$root.handleRequestError(error);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                } catch (err) {
                    this.$root.showAlert("Verifique los campos obligatorios");
                    this.loading = false;
                }
            }
        },
        applySelectedTemplate(){
            this.listTemplates.forEach((item) => {
                if(item.code === this.selected.templateCode){
                    this.templateSelected = item;//se selecciona el template
                    if('templateCode' in this.selected){
                        setTimeout(()=>{
                            const found = this.templateItems.options.find(element => element.value == this.selected.objectId);
                            if(found ===undefined)return false;
                            if(!found.disabled){
                                this.templateItemSelected = this.selected.objectId;
                            }
                        },0)
                    }

                }
            });
        }
    },
    computed: {
        ...mapState("reservation", ["viewModel"]),
        optionsTemplates() {
            let options = [];
            options.push({ value: {...this.templateModelDefault} , text: "Seleccione una opción" });
            this.listTemplates.forEach((item) => {
                if (item.langAvailables.includes(this.lang)) {
                    options.push({ value: item, text: item.title });
                }
            });
            return options;
        },
        descriptionTemplate() {
            return this.templateSelected?.description ?? "";
        },
        changeLang() {
            return this.lang != this.clientLang;
        },
        isSmsSelected() {
            return this.notificationsSelected.indexOf("sms") !== -1;
        },
        isMailSelected() {
            return this.notificationsSelected.indexOf("mail") !== -1;
        },
        varsTriggerPreviewSms() {
            return [this.templateSelected, this.lang, this.templateItemSelected];
        },
        templateItems() {
            let conf = {show:false,options:[]}
            switch(this.templateSelected.model){
                case "Payments":
                    conf.show= true
                    this.listPayments.forEach((item) => {
                        let disabled = item.status === "pending" ? false : true;
                        conf.options.push({
                            value: item.id,
                            text:  "Payment #"+item.id+" [$"+item.total+" "+(item.currency.toUpperCase())+"]",
                            disabled: disabled,
                        });
                    });
                break;
                case "TransportServices":
                    conf.show= true
                    this.viewModel.transportServices.forEach((item) => {
                        let disabled = item.status === "active" ? false : true;
                        conf.options.push({
                            value: item.id,
                            text: item.serviceNumber + " [" + item.trip + "]",
                            disabled: disabled,
                        });
                    });
                break;

            }
            return conf

        },

    },
    mounted() {
        this.email      = this.viewModel.clientEmail
        this.lang       = this.viewModel.clientLang;
        this.clientLang = this.viewModel.clientLang;
        if(Object.keys(this.selected).length>0 && 'templateCode' in this.selected){
            this.applySelectedTemplate();
        }
    },
    watch: {
        templateSelected:function(){
            this.templateItemSelected=0;
            this.previewSms = ""
        },
        varsTriggerPreviewSms: function () {
            if (this.isSmsSelected && this.templateSelected.code!= '' && (this.templateItems.show && this.templateItemSelected>0 || !this.templateItems.show )) {
                this.onPreviewSms();
            }
        },
    },
};
</script>

<style >
#reservations-history-list tr td {
    /*white-space: pre !important;*/
}
</style>
